import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import CountdownTimer from './CountdownTimer';
import Mapa from '../pages/recorrido/mapa/Mapa';
import Recorrido from './Recorrido';

export default function RecorridoContador() {
    // Fecha objetivo: 16 de diciembre de 2025 a las 10:00 AM
    const targetDate = '2025-12-16T10:00:00';
    const [hasReachedZero, setHasReachedZero] = useState(false);

    useEffect(() => {
        const checkIfReachedZero = () => {
            const now = new Date().getTime();
            const target = new Date(targetDate).getTime();
            const difference = target - now;

            if (difference <= 0) {
                setHasReachedZero(true);
            }
        };

        // Verificar inmediatamente
        checkIfReachedZero();

        // Verificar cada segundo
        const interval = setInterval(checkIfReachedZero, 1000);

        return () => clearInterval(interval);
    }, [targetDate]);

    // Si ya llegó a cero, mostrar el mapa
    if (hasReachedZero) {
        return <Recorrido />;
    }

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: { xs: '20px', sm: '40px', md: '60px' },
                boxSizing: 'border-box',
                backgroundColor: '#220015',
                overflow: 'hidden',
            }}
        >
            {/* Mapa como fondo con blur */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 0,
                    filter: 'blur(8px)',
                    pointerEvents: 'none',
                    '& *': {
                        pointerEvents: 'none !important',
                        cursor: 'default !important',
                    },
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <Mapa />
                </Box>
            </Box>

            {/* Overlay oscuro para mejor legibilidad */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0, 0.7)',
                    zIndex: 0,
                }}
            />

            {/* Contenido principal centrado */}
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: { xs: '30px', sm: '40px', md: '50px' },
                    width: '100%',
                    maxWidth: '1200px',
                }}
            >
                {/* Título opcional */}
                <Typography
                    sx={{
                        fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem', lg: '3.5rem' },
                        fontWeight: 600,
                        color: '#FFFFFF',
                        textAlign: 'center',
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
                        px: { xs: 2, sm: 3, md: 4 },
                    }}
                >
                    Recorrido Peñero 2026
                </Typography>

                {/* Countdown Timer */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <CountdownTimer targetDate={targetDate} />
                </Box>
            </Box>
        </Box>
    );
}

